<template>
    <div>
        <pre
            v-if="mode === 'read'"
        ><code ref="code" class="language-json" v-html="jsonHighlighted" /></pre>
        <b-form-textarea
            v-else
            v-model="jsonText"
            rows="5"
            max-rows="10"
            class="mb-3"
            :disabled="disabled"
        />
    </div>
</template>

<script>
import Prism from "prismjs";
Prism.manual = true;

export default {
    name: "JsonEditor",
    props: {
        json: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            jsonText: ""
        };
    },
    computed: {
        jsonHighlighted() {
            return Prism.highlight(this.jsonText, Prism.languages.json, "json");
        }
    },
    watch: {
        json() {
            this.jsonText = this._getJsonAsText();
        },
        jsonHighlighted() {
            this._highlight();
        },
        mode(mode) {
            this.jsonText = this._getJsonAsText();

            if (mode === "read") {
                this.$nextTick(() => {
                    this._highlight();
                });
            }
        }
    },
    methods: {
        _getJsonAsText() {
            return JSON.stringify(this.json, null, 4);
        },
        _highlight() {
            Prism.highlightAllUnder(this.$el);
        },
        getJsonText() {
            return this.jsonText;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~prismjs/themes/prism-coy.css";
</style>
